import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.service-slider__splide' ).length ) {
        const sliders = [];
        $( '.service-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 3,
            fixedWidth: '369px',
            focus: 'center',
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
                fixedWidth: false,
              },
            },
          } );

          const splideNav = slider.root.querySelector( '.service-slider__splide-nav' );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
              focus: 0,
            };
            if ( !isOverflow ) {
              splideNav.style.display = 'none';
            } else {
              splideNav.style.display = 'flex';
            }
          } );

          const progressBar = slider.root.querySelector( '.service-slider__progress-bar' );
          const progressAmount = slider.root.querySelector( '.service-slider__progress-amount' );

          if ( progressBar ) {
            slider.on( 'mounted refresh move', function( newIndex, prevIndex, destIndex ) {
              const end = slider.Components.Controller.getEnd() + 1;
              const slideCount = slider.Components.Slides.getLength();
              const rate = Math.min( ( slider.index + 1 ) / end, 1 );
              progressBar.style.width = String( 100 * rate ) + '%';

              /* updates sr-only text of progress bar */
              if ( slideCount >= 3 ) {
                $( progressAmount ).text( `${slider.index + 3} of ${slideCount} cards` );
              } else {
                $( progressAmount ).text( `${slideCount} of ${slideCount} cards` );
              }
            } );
          }

          slider.mount();

          const sliderId = $( this ).attr( 'id' );
          sliders[sliderId] = slider;

          let currentSlider = $( '.featured-services-tabs__tab-content' ).attr( 'id' );

          $( document ).on( 'change', '.js-featured-services-tabs__form', function( event ) {
            event.preventDefault();
            const formData = $( this ).serializeArray();

            let updatedSlider = currentSlider;
            let inputType = '';
            $( formData ).each( function( index, value ) {
              if ( value.value !== currentSlider ) {
                updatedSlider = value.value;
                inputType = value.name;
              }
            } );

            /* Show the slider and update aria attribute */
            $( `#${currentSlider}` ).removeClass( 'is-open' );
            $( `#${currentSlider}` ).attr( 'aria-hidden', true );
            $( `#${updatedSlider}` ).addClass( 'is-open' );
            $( `#${updatedSlider}` ).attr( 'aria-hidden', false );

            currentSlider = updatedSlider;

            const sliderId = $( `[data-tab-id=${currentSlider}]` ).attr( 'id' );

            /* refresh selected slider so the splide arrows and progress bar are displayed */
            sliders[sliderId].refresh();

            /* make sure form fields have same value */
            if ( inputType === 'featured-service-select' ) {
              $( this ).find( `.featured-services__radio-input[value="featured-services-tabs-tab-${currentSlider}"]` ).prop( 'checked', true );
            } else {
              select.val( currentSlider );
            }

            const select = $( this ).find( '.featured-services-tabs__select' );
            const announcement = $( this ).find( '.featured-services-tabs__announcement' );
            /* announce the slider has been displayed */
            const selectedTitle = $( `#${select.attr( 'id' )} option:selected` ).text();
            announcement.text( `${selectedTitle} slider is displayed` );

            return false;
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'service-slider', COMPONENT );
} )( app );
